import { useEffect } from "react";

// Travelpayouts Drive — official global monetization loader.
// Injected ONCE at the public-site layout level (never in /admin). The supplied
// Travelpayouts snippet is reproduced verbatim: same id/source/params/attributes/behavior.
// Drive only monetizes otherwise-unmonetized eligible travel references; it does not touch
// Hotelstrips' explicit affiliate CTAs, which are same-origin /api/go links (their external
// partner destinations exist only in the server-side 302 redirect, never as DOM anchors).
export function DriveLoader() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    // Safety: never load inside the admin/CMS.
    if (window.location.pathname.startsWith("/admin")) return;
    // Load exactly once per page/document.
    if (window.__tpDriveLoaded || document.getElementById("tp-drive-loader")) return;
    window.__tpDriveLoaded = true;

    const s = document.createElement("script");
    s.id = "tp-drive-loader";
    s.setAttribute("nowprocket", "");
    s.setAttribute("data-noptimize", "1");
    s.setAttribute("data-cfasync", "false");
    s.setAttribute("data-wpfc-render", "false");
    s.setAttribute("seraph-accel-crit", "1");
    s.setAttribute("data-no-defer", "1");
    s.setAttribute("data-cmp-ab", "2");
    s.text =
      '(function () { var script = document.createElement("script"); script.async = 1; script.setAttribute("data-cmp-ab","2"); script.src = \'https://tp-em.com/NDIxMjcy.js?t=421272\'; document.head.appendChild(script); })();';
    document.head.appendChild(s);
  }, []);

  return null;
}
